<div class="unlock">
    <h2 class="text-center text-white mb-2">Enter your rewards card code</h2>
    <p class="text-center text-white-50 mb-4">Codes are printed on your VIP mailer.</p>

    <form class="unlock-form" (ngSubmit)="submitCode()">
        <input
            type="text"
            class="form-control unlock-input"
            placeholder="Rewards card code"
            autocomplete="off"
            autocapitalize="characters"
            [formControl]="codeControl"
            [attr.disabled]="submitting ? '' : null"
        />

        <button
            class="btn btn-primary unlock-submit"
            [disabled]="submitting || codeControl.invalid"
        >
            {{ submitting ? 'Verifying…' : 'Unlock' }}
        </button>
    </form>

    <div class="unlock-error text-center mt-3" *ngIf="unlockError" role="alert">
        {{ unlockError }}
    </div>
</div>
